import { PiDesktopBold, PiMoonBold, PiSunBold } from 'react-icons/pi';

import { useTheme } from '#/hooks/useTheme';
import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '#/modules/commonComponents/dropdown-menu';

const MODES = [
  { key: 'light', label: '淺色模式', Icon: PiSunBold },
  { key: 'dark', label: '深色模式', Icon: PiMoonBold },
  { key: 'system', label: '根據系統', Icon: PiDesktopBold },
];

/** 右上角主題選單（淺色／深色／根據系統）；觸發鈕顯示目前選擇的模式。 */
const ThemeToggle = () => {
  const { preference, setPreference } = useTheme();
  const current = MODES.find((mode) => mode.key === preference) ?? MODES[0];
  const { Icon } = current;
  const label = `主題：${current.label}`;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon-lg"
          aria-label={label}
          title={label}
          className={cn(
            'rounded-full border border-gray-300 bg-panel shadow-xs',
            'text-gray-600',
            'hover:border-gray-400 hover:bg-gray-100 hover:text-gray-900',
            'aria-expanded:border-gray-400 aria-expanded:bg-gray-100 aria-expanded:text-gray-900',
          )}
        >
          <Icon size={20} aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuRadioGroup value={current.key} onValueChange={setPreference}>
          {MODES.map(({ key, label: modeLabel, Icon: ModeIcon }) => (
            <DropdownMenuRadioItem key={key} value={key} className="gap-2">
              <ModeIcon size={16} aria-hidden />
              {modeLabel}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ThemeToggle;
